// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/metar-remarks.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/metar-remarks/metar-remarks.js';

mount([g0]);
